module.exports = __webpack_public_path__ + "static/media/retweet-alt.b687e8a2.svg";